import { UserInformation } from "@/api/signin";
import { ReactNode, createContext, useContext } from "react";

interface AuthContextType {
	user: UserInformation;
}

export const AuthContext = createContext<AuthContextType | null>(null);

export const useAuth = () => {
	const context = useContext(AuthContext);
	if (!context) {
		throw new Error("useAuth must be used within an AuthProvider");
	}
	return context;
};

interface AuthProviderProps {
	children: ReactNode;
	value: AuthContextType;
}

export const AuthProvider = ({ children, value }: AuthProviderProps) => {
	return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
